import React from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import BannerEscalavel from '../BannerEscalavel';
import imgNotebook from '../img/notebook-catalogo.webp';
import imgDivisor from './img/divisor.svg';
import './style.scss';

const estatisticas = [
  '+ de 600 clientes satisfeitos',
  '+ de 1.000 catálogos desenvolvidos',
  '+ de 100 milhões de acessos por mês',
];

const BannerCatalogosInteligentes = () => {
  const intl = useIntl();

  return (
    <BannerEscalavel className="banner-catalogos-inteligentes">
      <div className="banner-catalogos-inteligentes-chevron esquerda" aria-hidden="true">
        <div className="losango losango-1" />
        <div className="losango losango-2" />
      </div>
      <div className="banner-catalogos-inteligentes-chevron direita" aria-hidden="true">
        <div className="losango losango-1" />
        <div className="losango losango-2" />
      </div>

      <img className="banner-catalogos-inteligentes-notebook" src={imgNotebook} alt="" />

      <div className="banner-catalogos-inteligentes-conteudo">
        <h2 className="titulo">{intl.formatMessage({ id: 'Ideia 2001 Catálogos Inteligentes' })}</h2>

        <p className="subtitulo">
          {intl.formatMessage({ id: 'Há mais de 25 anos desenvolvendo soluções para o mercado de autopeças.' })}
        </p>

        <div className="estatisticas">
          {estatisticas.map((id, index) => (
            <React.Fragment key={id}>
              {index > 0 && (
                <span className="divisor" aria-hidden="true">
                  <img src={imgDivisor} alt="" />
                </span>
              )}
              <p className={`estatistica estatistica-${index + 1}`}>{intl.formatMessage({ id })}</p>
            </React.Fragment>
          ))}
        </div>
      </div>
    </BannerEscalavel>
  );
};

export default BannerCatalogosInteligentes;
